var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBamboohr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_14720)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 0H3.6C1.61178 0 0 1.61177 0 3.6V20.4C0 22.3882 1.61178 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61177 22.3882 0 20.4 0Z",
    fill: "#73C41D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6818 9.82441C17.999 9.82441 20 11.7873 20 14.0712C20 16.5307 18.0815 18.4444 15.5476 18.4444C13.2474 18.4444 11.243 16.8532 11.243 14.2993V6H12.575L12.5755 11.0712L12.7334 10.9084C13.3132 10.3437 14.1397 9.82441 15.6818 9.82441ZM15.5476 17.253C17.4374 17.253 18.6379 15.9331 18.6379 14.1924C18.6379 12.5922 17.5033 11.0645 15.5778 11.0645C13.6525 11.0645 12.4585 12.4894 12.4585 14.2244C12.4585 15.9584 13.8746 17.253 15.5476 17.253ZM8.57204 7.00194C9.56609 8.0321 9.67057 8.60767 10.0234 9.60759L10.6148 11.5084C10.6148 11.5084 10.0316 11.401 9.55385 11.3303C8.99971 11.2478 8.75448 11.1671 8.05008 10.8853C7.34523 10.6035 6.70791 9.91428 6.08306 9.14566C5.45844 8.3766 4 7.16829 4 7.16829C4 7.16829 4.45102 7.19765 4.90815 7.3093C5.28279 7.40115 6.25825 7.71162 7.26454 8.2247C7.48778 8.33812 7.61153 8.41174 7.8316 8.54562C8.16612 8.74845 8.5181 9.05092 8.85489 9.3863C9.25083 9.78017 9.59759 10.0969 9.89358 10.4494C9.5713 9.86713 8.7359 7.77078 7.10272 6.0405C6.94271 5.87103 8.23162 6.64877 8.57204 7.00194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_14720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBamboohr);
export default __webpack_public_path__ + "static/media/bamboohr.83ecaf212b44d465284d02a3d4570b59.svg";
export { ForwardRef as ReactComponent };